/**
 * Modal de refus d'une demande d'inscription
 */
import React from "react";
import { useFetchTypeRefusDemandeInscriptionQuery } from "../../../../redux/slice/api/staticData";
import { ITypeRefusDemandeInscription } from "../../../../models/interfaces/ITypeRefusDemandeInscriptionList";

interface RefuseModalProps {
  show: boolean;
  isUpdating: boolean;
  explicationRefus: string;
  selectedTypeRefus: number | null;
  onClose: () => void;
  onConfirm: () => void;
  onExplicationChange: (value: string) => void;
  onTypeRefusChange: (typeRefus: ITypeRefusDemandeInscription | null) => void;
}

const RefuseModal: React.FC<RefuseModalProps> = ({
  show,
  isUpdating,
  explicationRefus,
  selectedTypeRefus,
  onClose,
  onConfirm,
  onExplicationChange,
  onTypeRefusChange
}) => {
  const { data: typeRefusData } = useFetchTypeRefusDemandeInscriptionQuery(undefined, {
    skip: !show
  });

  if (!show) {
    return null;
  }

  const handleTypeRefusSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = parseInt(e.target.value);
    if (selectedId) {
      const selectedType = typeRefusData?.TypeRefusDemandeInscriptions?.find(
        (type) => type.Id === selectedId
      );
      if (selectedType) {
        onTypeRefusChange(selectedType);
        // Pré-remplir le champ de texte avec la description
        onExplicationChange(selectedType.Description);
      }
    } else {
      onTypeRefusChange(null);
    }
  };

  return (
    <div className="modal show d-block" tabIndex={-1} style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Refuser la demande d&apos;inscription</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={isUpdating}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label htmlFor="typeRefus" className="form-label">
                Type de refus <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                id="typeRefus"
                value={selectedTypeRefus || ""}
                onChange={handleTypeRefusSelect}
                disabled={isUpdating}
              >
                <option value="">Sélectionner un type de refus...</option>
                {typeRefusData?.TypeRefusDemandeInscriptions?.map((type) => (
                  <option key={type.Id} value={type.Id}>
                    {type.Libelle}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="explicationRefus" className="form-label">
                Explication du refus <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control"
                id="explicationRefus"
                rows={4}
                value={explicationRefus}
                onChange={(e) => onExplicationChange(e.target.value)}
                placeholder="Veuillez préciser la raison du refus..."
                disabled={isUpdating}
              ></textarea>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={isUpdating}
            >
              Annuler
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={onConfirm}
              disabled={isUpdating || !explicationRefus.trim() || !selectedTypeRefus}
            >
              {isUpdating ? "Traitement..." : "Confirmer le refus"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefuseModal;
